export default __webpack_public_path__ + "static/media/Cloak of Furor.b71aed08.jpg";